import React from 'react';
import { Helmet } from 'react-helmet';
import { convertGalleryIdToName } from 'util/gallery';

import './index.css';

const GalleryImage = ({ history, match, location }) => {
    const { src, gallery } = match.params;

    const imageSrc = decodeURIComponent(src);
    const galleryName = convertGalleryIdToName(gallery);

    const isModal = location.state && location.state.modal;
    const back = e => {
        e.stopPropagation();
        history.push(`/gallery/${gallery}`);
    };

    return (
        <section
            className='GalleryImage-modal'
            onClick={isModal ? back : null}
            style={{ cursor: isModal ? 'pointer' : 'default' }}
        >
            <Helmet>
                <title>{galleryName}</title>
                <meta property='og:title' content={galleryName} />
                <meta property='og:image' content={imageSrc} />
                <meta name="twitter:card" content={imageSrc} />
            </Helmet>
            <span onClick={back} className='GalleryImage-back'>
                {isModal ? 'Back' : `To ${galleryName} Album` }
            </span>
            <img src={imageSrc} className='GalleryImage-image' alt={galleryName} />
        </section>
    );
};

export default GalleryImage;



// WEBPACK FOOTER //
// ./src/components/GalleryImage/index.js